module.exports = "/_next/static/images/uv-text-1-712a11aad6e0c170b491cc879e3fe4c5.png";